import { cn } from '@/lib/utils';
import { useI18n } from '@/providers/i18n';

type TextCollapsedSummaryProps = {
  data: Record<string, any> | undefined;
  className?: string;
};

const tiptapToText = (node: any): string => {
  if (!node) return '';
  if (typeof node === 'string') return node;
  if (Array.isArray(node)) return node.map(tiptapToText).join('');
  if (typeof node === 'object') {
    if (node.type === 'text' && typeof node.text === 'string') return node.text;
    const children = Array.isArray(node.content) ? node.content.map(tiptapToText).join('') : '';
    // Insert newlines for paragraph-like blocks
    if (/^(paragraph|heading|blockquote|codeBlock|taskItem)$/i.test(node.type || '')) {
      return children + '\n';
    }
    return children;
  }
  return '';
};

const getTextPreview = (d: any): string | undefined => {
  try {
    const t1 = typeof d?.text === 'string' ? String(d.text) : '';
    if (t1.trim()) return t1.trim();
    const gt = typeof d?.generated?.text === 'string' ? String(d.generated.text) : '';
    if (gt.trim()) return gt.trim();
    const c = d?.content;
    if (c && typeof c === 'object') {
      const plain = tiptapToText(c).replace(/\n{3,}/g, '\n\n').trim();
      if (plain) return plain;
    }
  } catch {}
  return undefined;
};

export const TextCollapsedSummary = ({ data, className }: TextCollapsedSummaryProps) => {
  const { t } = useI18n();
  const d = (data ?? {}) as any;
  const text = getTextPreview(d);

  if (!text) {
    return (
      <div className={cn('flex h-full w-full items-center justify-center text-sm text-muted-foreground', className)}>
        {t('No content')}
      </div>
    );
  }

  return (
    <div className={cn('flex h-full w-full items-center justify-center p-3', className)}>
      <div className="w-full text-sm leading-snug text-foreground whitespace-pre-wrap break-words line-clamp-6">
        {text}
      </div>
    </div>
  );
};


